namespace TR {
    class PriceFilter {
        model: any;
        aggregate: any;
        range: any;
        people: any;

        constructor(
            private $scope: ng.IScope,
            private occupancyService: Core.OccupancyService,
            broker: Core.Broker
        ) {
            $scope.$watch('pf.aggregate', this.setRange.bind(this), true);
            $scope.$watch('pf.model', m => {
                if (m === null) { this.reset(undefined); }
            });
            broker.subscribe('priceFilter', 'RESETPRICE', this.reset.bind(this));

            $scope.$on('$destroy', () => {
                broker.unsubscribe('priceFilter');
            });
        }

        setRange(a) {
            if (!a) { return; }

            if (_.get(this.model, 'Min') === 0) {
                this.model.Min = a.Min;
            }


            if (_.get(this.model, 'Max') === 0) {
                this.model.Max = a.Max;
            }

            this.range = this.model
                ? { Min: this.model.Min, Max: this.model.Max }
                : { Min: a.Min, Max: a.Max };

            this.people = this.occupancyService.getNumberOfNonInfantPassengers();
        }

        updateModel() {
            // if model already in sync skip
            if (this.model &&
                ((this.model.Min === this.range.Min) && (this.model.Max === this.range.Max))) {
                return;
            }

            // if new value is the default one reset
            if (this.range.Min === this.aggregate.Min && this.range.Max === this.aggregate.Max) {
                return this.model = null;
            }

            return this.model = { Min: this.range.Min, Max: this.range.Max };
        }

        isSet() {
            return !!this.model;
        }

        reset(e) {
            if (e && e.data) {
                this.range[e.data] = this.aggregate[e.data];
                return this.model[e.data] = this.aggregate[e.data];
            }
            this.range = { Min: this.aggregate.Min, Max: this.aggregate.Max };
            this.model = null;
        }


    }

    angular
        .module('TR')
        .directive('priceFilter', (): ng.IDirective => {
            return {
                scope: {},
                templateUrl: 'partials/home/directivetemplate?type=PriceFilter',
                bindToController: {
                    aggregate: '=',
                    model: '=',
                    priceMode: '='
                },
                controller: PriceFilter,
                controllerAs: 'pf'
            };
        });

    class PriceFilterLabel {

        public static getTemplate() {
            return `
                <span ng-if="pf.isSet('Min')">
                    <a
                        href="#"
                        class="filter-criterion-toggle"
                        ng-click="pf.remove('Min')">
                        <span> {{pf.getName('Min', pf.priceMode)}} </span>
                    </a>
                </span>
                <span ng-if="pf.isSet('Max')">
                    <a
                        href="#"
                        class="filter-criterion-toggle"
                        ng-click="pf.remove('Max')">
                        <span> {{pf.getName('Max', pf.priceMode)}} </span>
                    </a>
                </span>
            `;
        }

        model: any;
        aggregate: any;
        sentenceMax: string;
        sentenceMin: string;
        currencyFilter: any;
        currencySymbol: any;

        constructor(
            $scope: ng.IScope,
            private $filter: any,
            private broker: Core.Broker,
            analytics: any,
            private occupancyService: Core.OccupancyService
        ) {
            this.currencySymbol = TRPCONFIG.Domain.CurrencyCode;
            this.currencyFilter = this.$filter('roundedCurrency');

            $scope.$watch('pf.model', (value: any) => {
                if (!value) { return; }
                analytics.track('mixpanel', 'HolidayDealsFilterPrice');
            });
        }

        getName(end, priceMode) {
            const price = end === 'Min' ? this.model.Min : this.model.Max;
            const priceSentence = end === 'Min' ? this.sentenceMin : this.sentenceMax;
            const people = this.occupancyService.getNumberOfNonInfantPassengers();

            return priceSentence.replace(
                '{0}',
                this.currencyFilter(priceMode === 1 ? price : price / people, this.currencySymbol)
            );
        }

        isSet(end) {
            return !!this.model && this.model[end] !== this.aggregate[end] && this.model[end] !== 0;
        }

        remove(end) {
            this.broker.publish('RESETPRICE', end);
        }
    }

    angular
        .module('TR')
        .directive('priceFilterLabel', (): ng.IDirective => {
            return {
                scope: {},
                template: PriceFilterLabel.getTemplate(),
                bindToController: {
                    aggregate: '=',
                    model: '=',
                    priceMode: '=',
                    sentenceMin: '@',
                    sentenceMax: '@'
                },
                controller: PriceFilterLabel,
                controllerAs: 'pf'
            };
        });

}
